import React from 'react'
import {
  TablePagination,
  TablePaginationProps,
  SxProps,
  Theme,
} from '@mui/material'
import PaginationActions from './PaginationActions'

interface AdvancedPaginationProps {
  count: number
  page: number
  rowsPerPage: number
  onPageChange: TablePaginationProps['onPageChange']
  onRowsPerPageChange: TablePaginationProps['onRowsPerPageChange']
  rowsPerPageOptions?: number[]
  labelRowsPerPage?: string
  sx?: SxProps<Theme>
}

const AdvancedPagination: React.FC<AdvancedPaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 100],
  labelRowsPerPage = 'Records per page:',
  sx,
}) => {
  const baseStyles = (theme: Theme) => ({
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 0,
      paddingRight: 0,
      flexWrap: 'wrap',
      gap: 1,
    },
    '& .MuiTablePagination-selectLabel': {
      margin: 0,
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
    },
    '& .MuiTablePagination-displayedRows': {
      margin: 0,
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
    },
    '& .MuiTablePagination-select': {
      color: theme.palette.text.primary,
      fontSize: '0.875rem',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTablePagination-actions': {
      marginLeft: 1,
    },
    '& .MuiIconButton-root': {
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.light}14`,
        color: theme.palette.primary.main,
      },
      '&.Mui-disabled': {
        color: theme.palette.grey[400],
      },
    },
  })

  const combinedSx: SxProps<Theme> = Array.isArray(sx)
    ? [baseStyles, ...sx]
    : sx
      ? [baseStyles, sx]
      : baseStyles

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      labelRowsPerPage={labelRowsPerPage}
      labelDisplayedRows={() => ''}
      ActionsComponent={PaginationActions}
      sx={combinedSx}
    />
  )
}

export default AdvancedPagination
